import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { AdministradorService } from './administrador.service';

@Component({
  selector: 'app-administrador',
  templateUrl: './administrador.component.html',
  styleUrls: ['./administrador.component.scss']
})
export class AdministradorComponent implements OnInit{
  hide_password : boolean = true;
  readonly patron_contrasena : string = "^(?=.*\\d)(?=.*[\\.\\,\\_\\|\\(-\\)\\$-\\&])(?=.*[A-Z])(?=.*[a-z])\\S{8,16}$";
  addressForm = this.fb.group({
    nombre: [null, Validators.required],
    apellido: [null, Validators.required],
    correo: [null, [Validators.email, Validators.required]],
    telefono: [null, Validators.required],
    ind_estado: [true]
  });

  constructor(private fb: FormBuilder,
              private admin_serv : AdministradorService) {}

  ngOnInit(): void {

    if(this.admin_serv.json_usuario && this.admin_serv.json_usuario?.id_usuario){
      //contraseña no es obligatorio para edicion
      this.addressForm.addControl('contrasena', new FormControl(null, [Validators.pattern(this.patron_contrasena)]));
    }else{
      this.addressForm.addControl('contrasena', new FormControl(null, [Validators.required, Validators.pattern(this.patron_contrasena)]));
    }
    this.llenar_forma();
  }

  onSubmit() {
    if (!this.admin_serv.json_usuario){
      this.crear_usuario();
    }else{
      this.actualizar_usuario();
    }
  }

  crear_usuario(){
    let value = this.addressForm.value;

    let data_form = {
        "app": this.admin_serv.id_aplicacion,
        "password": value.contrasena,
        "first_name": value.nombre,
        "last_name": value.apellido,
        "email": value.correo,
        "ind_estado": value.ind_estado ? 1 : 0,
        "json_datosPersonales": {
            "telefono": value.telefono
        }
    }

    this.admin_serv.crear_administrador(data_form);
  }

  llenar_forma(){
    let usuario = this.admin_serv.json_usuario;

    if (usuario){

      this.addressForm.get('nombre').setValue(usuario.nombres);
      this.addressForm.get('apellido').setValue(usuario.apellidos);
      this.addressForm.get('correo').setValue(usuario.usuario);
      this.addressForm.get('telefono').setValue(usuario.telefono);
      this.addressForm.get('ind_estado').setValue(usuario.ind_estado);

    }
  }

  actualizar_usuario(){
    let value = this.addressForm.value;
    let data_form = {
      "app": this.admin_serv.id_aplicacion,
      "first_name": value.nombre,
      "last_name": value.apellido,
      "email": value.correo,
      "ind_estado": value.ind_estado ? 1 : 0,
      "json_datosPersonales": {
          "telefono": value.telefono
      }
    }

    if(value.contrasena && value.contrasena.trim().length){      
      data_form["password"] = value.contrasena;
    }
    data_form['id_usuario'] = this.admin_serv.json_usuario.id_usuario;
    this.admin_serv.acutalizar_usuario(data_form);
  }
}
